import { ACTION_TYPES } from "./consts";

export const actions = {
  getGlobalSettings: (globalSettings) => ({
    type: ACTION_TYPES.getGlobalSettings,
    payload: globalSettings,
  }),
};
